import { useEffect } from 'react';
import { useAppState } from './app-state';
import { useBehaviour } from './editor-settings';
import { useServices } from './services-registry';
import { useSubscribeToPageNavigation } from './page-navigation';
import { ViewMode } from '../types/host-sdk';

export const useVisitorOnPageReporter = () => {
  const { serverApi, hostSdk } = useServices();
  const { appState } = useAppState();
  const { pageId, pageTitle } = useSubscribeToPageNavigation();
  const { visitorId, viewMode } = appState;
  const { pagesWithChat } = useBehaviour();

  useEffect(() => {
    if (!visitorId || !pageId || !pageTitle || viewMode() === ViewMode.Editor) {
      return;
    }

    const isChatEnabledOnPage =
      viewMode() === ViewMode.Standalone ||
      pagesWithChat.includes(pageId) ||
      pagesWithChat.includes('*');

    if (isChatEnabledOnPage) {
      serverApi.reportVisitorOnPageEvent(
        pageId,
        visitorId,
        hostSdk.getAid(),
        pageTitle,
      );
    }
  }, [pageId, pageTitle, visitorId, hostSdk, viewMode, pagesWithChat]);
};
